import angular from 'angular';
import isEmpty from 'lodash/isEmpty';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  subComponent: state.statsbar.activeComponent,
  loyaltyStatistics: state.user.loyaltyStatistics,
});

angular
  .module('myConsultApp')
  .controller('anonymizeUserController', ($ngRedux, $rootScope, $scope, $http, ENV, $interval, $timeout) => {
    $scope.initData = () => {
      $scope.redemptions = {
        rewards: [],
      };
      $scope.selectedReward = {
        reward: null,
        quantity: '',
      };
      $scope.initialReward = 'Select a Reward';
      $scope.redeemTotal = 0;
      $scope.redeemError = '';
      $scope.errors = [];
      $scope.filterRewards = [];
      $scope.processing_anonymize_user = false;
      $scope.loadingRewards = false;
      $scope.displayRedemptionOption = false;
      $scope.processing_anonymize_user_redemption = false;
      $scope.processing_anonymize_user_redemption_status = '';
      $scope.user_redemption_succeeded = false;
      $scope.fullRewardsList = [];
      $scope.display_reward_options = true;
    };

    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      $scope.initData();
    };

    $scope.toggleRedemptionOption = () => {
      $scope.displayRedemptionOption =  $scope.displayRedemptionOption ? false : true;
    }

    $scope.validQuantity = () => {
      $scope.selectedReward.quantity = $scope.selectedReward.quantity.replace(/[^0-9]+/g, '');
    };

    $scope.filterRewardList = () => {
      const userAvailablePoints = $scope.userInfo.redeemable_points - $scope.redeemTotal;
      let uniqueFilterRewardsArray = [];
      angular.forEach($scope.fullRewardsList, function (reward) {
        if (reward.point_cost > userAvailablePoints){
          uniqueFilterRewardsArray = [...uniqueFilterRewardsArray, reward];
        }
      });
      angular.forEach($scope.redemptions.rewards, function (reward) {
        let alreadyExists = false;
        if(uniqueFilterRewardsArray.length) {
          angular.forEach(uniqueFilterRewardsArray, function (existing_reward) {
            if(existing_reward.id == reward.reward.id){
              alreadyExists = true;
            }
          });
        }
        if(!alreadyExists){
          uniqueFilterRewardsArray = [...uniqueFilterRewardsArray, reward.reward];
        }
      });
      $scope.filterRewards = uniqueFilterRewardsArray;
      if(($scope.filterRewards.length + 1) == $scope.fullRewardsList.length){
        $scope.display_reward_options = false;
      } else {
        $scope.display_reward_options = true;
      }
    };

    $scope.addReward = () => {
      if (isEmpty($scope.selectedReward.reward) || !$scope.selectedReward.reward.id) {
        $scope.redeemError = 'Please select a reward.';
        return;
      }
      if (
        Number.isNaN($scope.selectedReward.quantity) ||
        Number($scope.selectedReward.quantity) === 0
      ) {
        $scope.redeemError = 'Please provide a valid quantity.';
        return;
      }

      const newRedeemTotal =
        $scope.redeemTotal +
        Number($scope.selectedReward.reward.point_cost) * Number($scope.selectedReward.quantity);

      if (newRedeemTotal > $scope.userInfo.redeemable_points) {
        $scope.redeemError = 'User does not have enough points to redeem selected reward.';
        return;
      }

      const reward = $scope.selectedReward;
      $scope.redemptions.rewards.push(reward);
      $scope.redeemTotal = newRedeemTotal;
      $scope.filterRewardList();
      $scope.redeemError = '';
      $scope.selectedReward = {
        reward: null,
        quantity: '',
      };
    };

    $scope.removeReward = (index) => {
      const removedReward = $scope.redemptions.rewards[index];
      $scope.redeemTotal -=
        Number(removedReward.quantity) * Number(removedReward.reward.point_cost);
      $scope.redemptions.rewards.splice(index, 1);
      $scope.filterRewardList();
      $scope.errors = [];
    };

    $scope.setRewardList = () => {
      $scope.loadingRewards = true;
      return $scope
        .getRewards($http, ENV, {
          enabled: 'true',
          available_for_order: 'true',
          paginate: false,
          order: 'parent_contentstack_uid,title',
        })
        .then((res) => {
          const userHasCard = $scope?.loyaltyStatistics?.redemption_status?.card_exists;
          $scope.fullRewardsList = res?.rewards?.filter((reward) => {
            // If loyalty statistics redemption_status.card_exists value is false, don’t show “reload card” option on rewards list
            if (reward.reward_type === 'reload_card' && !userHasCard) {
              return false;
            }
            return true;
          });
          $scope.filterRewardList();
          $scope.loadingRewards = false;
          return {
            rewards: $scope.fullRewardsList,
          };
        })
        .catch((e) => {
          $scope.loadingRewards = false;
          console.warn(e);
        });
    };

    $scope.selectReward = (option) => {
      $scope.selectedReward.reward = option;
    };

    $scope.submitAnonymizationRedemption = () => {
      const payload = {
        redemptions: {
          user_id: $rootScope.userId,
          rewards: $scope.redemptions.rewards.map((reward) => ({
            reward_id: reward.reward.id,
            quantity: reward.quantity,
          })),
          usps_validate: false,
        },
      };
      $scope
        .createRedemption($http, ENV, payload)
        .then((res) => {
          $scope.$apply(() => {
            $scope.initData();
            $rootScope.refreshLoyaltyStatistics();
            $rootScope.getData();
            $scope.processing_anonymize_user_redemption = true;
            $scope.pollRedemptionStatus(res['redemptions-group'].redemptions[0].id);
          });
        })
        .catch((error) => {
          $scope.processing_anonymize_user = false;
          $scope.processing_anonymize_user_redemption = false;
          $scope.processing_anonymize_user_redemption_status = '';
          if (error.data['redemptions-groups']) {
            $scope.$apply(() => {
              $scope.errors = error.data['redemptions-groups'];
            });
            return;
          }
          const errors = error.data['redemptions-group'];
          let result = [];
          if (errors) {
            result = Object.keys(errors)
              .map((key) => {
                const keyString = key
                  .split('_')
                  .map((item) => $scope.capitalize(item))
                  .join(' ');
                const value = errors[key];
                if (Array.isArray(value)) {
                  return value.map((x) => `${keyString}: ${x}`);
                }
                return `${keyString}: ${errors[key]}`;
              })
              .flat(1);
          } else {
            result.push('Something went wrong. Please try again.');
          }

          $scope.$apply(() => {
            $scope.errors = result;
          });
        });
    };

    $scope.submitAnonymization = () => {
      $scope.processing_anonymize_user = true;
      if($scope.displayRedemptionOption && $scope.redemptions.rewards.length){
        $scope.submitAnonymizationRedemption();
      } else {
        $scope.anonymizeUser(null);
      }
    };

    let redemptionPromise;
    $scope.pollRedemptionStatus = (redemptionId) => {
      // if promise exists, cancel it to prevent duplication of intervals
      if (angular.isDefined(redemptionPromise)) {
        $interval.cancel(redemptionPromise);
        redemptionPromise = undefined;
      }
      redemptionPromise= $interval(() => {
        $scope.getRedemptionStatus(redemptionId);
      }, 6000);
    }

    $scope.getRedemptionStatus = (redemptionId) => {
      $scope
      .getRedemption($http, ENV, redemptionId)
      .then((res) => {
        $scope.$apply(() => {
          $scope.processing_anonymize_user_redemption_status = res.status.name;
          if (res.status.id == 1){
            $interval.cancel(redemptionPromise);
            redemptionPromise = undefined;
            $scope.processing_anonymize_user_redemption = false;
            $scope.user_redemption_succeeded = true;
            $rootScope.refreshLoyaltyStatistics();
            $scope.anonymizeUser(redemptionId);
          }
        });
      });
    };

    $scope.anonymizeUser = (redemptionId) => {
      $scope.processing_anonymize_user_redemption_status = '';
      const payload = {
        anonymization: {
          redeem_points_id: redemptionId,
        },
      };
      $scope
        .anonymizeUserProfile($http, ENV, $rootScope.userId, payload)
        .then((res) => {
          $scope.$apply(() => {
            $scope.initData();
            $rootScope.refreshLoyaltyStatistics();
            $rootScope.getData();
            $scope.getUser($http, ENV, $rootScope.userId);
            //$rootScope.closeComponent({ shouldHardClose: !$rootScope.isUserRoute });
            $rootScope.onDisplayAnonymizationDetail({
              userId: $rootScope.userId,
              anonymizationId: res.id,
            });
          });
        })
        .catch((error) => {
          $scope.processing_anonymize_user = false;
          if (error.data['anonymization']) {
            $scope.$apply(() => {
              $scope.errors = error.data['anonymization'];
            });
            return;
          }
          const errors = error.data['anonymization'];
          let result = [];
          if (errors) {
            result = Object.keys(errors)
              .map((key) => {
                const keyString = key
                  .split('_')
                  .map((item) => $scope.capitalize(item))
                  .join(' ');
                const value = errors[key];
                if (Array.isArray(value)) {
                  return value.map((x) => `${keyString}: ${x}`);
                }
                return `${keyString}: ${errors[key]}`;
              })
              .flat(1);
          } else {
            result.push('Something went wrong. Please try again.');
          }

          $scope.$apply(() => {
            $scope.errors = result;
          });
        });
    };

    $scope.close = () => {
      $rootScope.closeComponent({ shouldHardClose: !$rootScope.isUserRoute });
      $rootScope.getData();
      $rootScope.refreshUser();
    };

    $scope.$watch('subComponent', (newValue, oldValue) => {
      if (oldValue === 'anonymize-user') {
        $scope.initData();
        if (!$rootScope.isUserRoute) {
          const e = document.getElementById('redeemed-user-name_value');
          if (e) {
            e.value = '';
            angular.element(e).triggerHandler('input');
          }
          $scope.setActiveUser({});
          $scope.setActiveUserInfo({});
        }
      }
    });

    $scope.init();
    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      $scope.displayRedemptionOption = false;
      $scope.processing_anonymize_user_redemption = false;
      $scope.processing_anonymize_user = false;
      $scope.processing_anonymize_user_redemption_status = '';
      $interval.cancel(redemptionPromise);
    });
  })
  .directive('anonymizeUser', () => {
    return {
      templateUrl: 'templates/v2/anonymize-user.html',
    };
  });
